export const messages = {
  en: {
    shopSetting: {
      queryCondition: 'Query Conditions',
      selectSettingType: 'Please select setting type',
      inputSettingName: 'Please input setting name',
      inputSettingKey: 'Please input setting key',
      shopSettings: 'Shop Settings',
      typeName: 'Type Name',
      settingName: 'Setting Name',
      settingKey: 'Setting Key',
      settingValue: 'Setting Value',
      addSetting: 'Add Setting',
      editSetting: 'Edit Setting',
      deleteConfirm: 'Delete Confirmation',
      deleteShopSettingConfirm: 'Are you sure to delete this shop setting?',
      settingType: 'Setting Type',
      selectSettingTypeRequired: 'Required, please select setting type',
      selectSettingNameRequired: 'Required, please select setting name',
      inputSettingKeyRequired: 'Required, please input setting key',
      inputSettingValueRequired: 'Required, please input setting value',
      inputRemarkOptional: 'Optional, please input remark',
      settingTypeRequired: 'Setting type is required',
      settingNameRequired: 'Setting name is required',
      settingKeyRequired: 'Setting key is required',
      settingValueRequired: 'Setting value is required',
      remarkRequired: 'Remark is required',
      remark: 'Remark'
    }
  },
  zh: {
    shopSetting: {
      queryCondition: '查询条件',
      selectSettingType: '请选择配置类型',
      inputSettingName: '请输入配置名称',
      inputSettingKey: '请输入配置键名称',
      shopSettings: '店铺配置',
      typeName: '类型名称',
      settingName: '配置名称',
      settingKey: '配置KEY',
      settingValue: '配置取值',
      addSetting: '添加配置',
      editSetting: '修改配置',
      deleteConfirm: '删除确认',
      deleteShopSettingConfirm: '确定删除店铺配置信息吗？',
      settingType: '配置类型',
      selectSettingTypeRequired: '必填，请选择配置类型',
      selectSettingNameRequired: '必填，请选择配置名称',
      inputSettingKeyRequired: '必填，请填写配置KEY',
      inputSettingValueRequired: '必填，请填写配置取值',
      inputRemarkOptional: '选填，请填写备注',
      settingTypeRequired: '配置类型不能为空',
      settingNameRequired: '配置名称不能为空',
      settingKeyRequired: '配置KEY不能为空',
      settingValueRequired: '配置取值不能为空',
      remarkRequired: '备注信息不能为空',
      remark: '备注'
    }
  }
}